

import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SpinnerIcon } from './icons/SpinnerIcon';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) {
      // Redirect to the homepage where the login modal is available
      navigate('/');
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-[#1F2937]">
        <SpinnerIcon />
        <span className="text-[#6B7280] ml-3">Loading...</span>
      </div>
    );
  }

  if (user) {
    return <>{children}</>;
  }

  // Render nothing while redirecting
  return null;
};